import API from '../api/index';
import { wxAddCard, wxOpenCard } from '../sdk/weixin';

export default {
  data() {
    return {
      grabCount: 0,
      cardId: null,
      code: null,
      cardExt: null,
      canDraw: true,
      canGrab: true,
      canCheck: true
    };
  },
  methods: {
    async handleWechatAddCard() {
      if (!this.$store.state.cardInfo || !this.$store.state.cardDetail) {
        return;
      }
      try {
        // 添加卡券
        wxAddCard();
      } catch (e) {
        console.warn(e);
        // 弹繁忙页
        this.busyPopupShow();
      }
    },
    async getCard(grab = false) {
      let res = await API.getH5CardExt().catch(e => {
        console.warn(e);
        this.busyState = e.limited ? 503 : 1;
        // 弹繁忙页
        this.busyPopupShow();
      });

      if (res) {
        // 记录卡券
        this.$store.commit('RECORD_CARD', res.result);

        // 抽奖成功，获取卡券签名失败情况下
        if (grab) {
          setTimeout(() => {
            this.grab();
          });
        }
      }
    },
    async check() {
      if (!this.logined || this.eventState !== 1) {
        return;
      }
      if (!this.canDraw) {
        return;
      } 
      this.canDraw = false;
      this.draw();
    },
    async checkCard() {
      if (!this.canCheck) {
        return;
      }
      this.canCheck = false;
      if (this.received !== 1) {
        this.canCheck = true;
        return;
      }
      this.fiboClick('btn-rewin-look', '立即查看');
      let cardId = this.$store.state.userInfo.cardId || this.cardId;
      let code = this.$store.state.userInfo.code || this.code;
      if (cardId && code) {
        wxOpenCard({
          cardId: cardId,
          code: code
        });
      } else {
        let res = await API.getH5CardExt().catch(e => {
          console.warn(e);
          this.busyState = e.limited ? 503 : 1;
          // 弹繁忙页
          this.busyPopupShow();
        });
        if (res) {
          // 记录卡券
          this.$store.commit('RECORD_CARD', res.result);
          let ext = JSON.parse(res.result.cardExt);
          wxOpenCard({
            cardId: res.result.cardId,
            code: ext.code
          });
        }
      }
      this.canCheck = true;
    },
    async draw() {
      if (this.cardType !== 0) {
        this.canDraw = true;
        // 弹出相应的奖品
        this.firstPopupShow();
        return;
      }
      this.fiboClick('btn-home-go', '热血开抢');
      // 抽奖
      let res = await API.postH5Lottery().catch(e => {
        console.warn(e);
        this.busyState = e.limited ? 503 : 1;
        // 弹繁忙页
        this.busyPopupShow();
      });

      if (res) {
        // 记录结果
        this.cardType = res.result.cardType;
        // 弹窗
        this.firstPopupShow();
      }
      this.canDraw = true;
    },
    async grab() {
      if (!this.canGrab) {
        return;
      }
      this.canGrab = false;
      if (this.cardType === 0) {
        this.canGrab = true;
        return;
      }
      this.cardType === 1
        ? this.fiboClick('btn-win-one', '10元券-立即领取')
        : this.cardType === 2
        ? this.fiboClick('btn-win-two', '30元券-立即领取')
        : this.cardType === 3
        ? this.fiboClick('btn-win-three', '50元券-立即领取')
        : null;

      this.grabCount++;

      // 考虑用户点击领取卡券后迅速关闭页面导致回调失败而没有记录领取状态，从后台获取卡券状态
      if (this.received === 0 && this.grabCount >= 3) {
        let res = await API.getH5Info().catch(e => {
          console.warn('error in "Home-check":', e);
          this.busyState = e.limited ? 503 : 1;
          // 弹繁忙页
          this.busyPopupShow();
        });

        if (res) {
          // 显示中奖
          this.cardType = res.result.cardType;
          this.received = res.result.received;
          this.cardId = res.result.cardId;
          this.code = res.result.code;
          if (this.received === 1) {
            this.canGrab = true;
            this.firstPopupShow();
            return;
          }
        } else {
          this.canGrab = true;
          return;
        }
      }

      if (this.cardId && this.cardExt) {
        console.log(this.cardId, this.cardExt);
        // 正常添加卡券
        wxAddCard(
          {
            cardId: this.cardId,
            cardExt: this.cardExt
          },
          () => {
            console.log('添加成功');
            setTimeout(() => {
              this.received = 1;
              this.firstPopupShow();
            });
          }
        );
      } else {
        let res = await API.getH5CardExt().catch(e => {
          console.warn(e);
          this.busyState = e.limited ? 503 : 1;
          // 弹繁忙页
          this.busyPopupShow();
        });

        if (res) {
          this.cardId = res.result.cardId;
          this.code = JSON.parse(res.result.cardExt).code;
          this.cardExt = res.result.cardExt;
          // 正常添加卡券
          wxAddCard(res.result, () => {
            console.log('添加成功');
            setTimeout(() => {
              this.received = 1;
              this.firstPopupShow();
            });
          });
        }
      }
      this.canGrab = true;
    }
  }
};
